import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import $ from "jquery";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Button from "@mui/material/Button";
import {setLookActiveCategory, setLookActiveFeature, setLookParentKeys} from "../../../../../actions/lookFunctions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {getAllNotMatchingPartIds} from "../../lookFunctions";

const LookFeatureMatchingStyleAlertModal = (props) => {

  const {styleAlertModalOpened, setStyleAlertModalOpened, anchorEl, lookFeature, setLookActiveCategory,
    setLookActiveFeature, setLookParentKeys, isMobile, deletedFromCart} = props;

  const handleClose = (event) => {
    if (anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }
    setStyleAlertModalOpened(false);
  };

  const reviewYourLookButtonClick = (event) => {
    setLookActiveCategory(null);
    setLookActiveFeature(null);
    // setLookParentKeys([lookFeature.partId]);
    if (!deletedFromCart) {
      setLookParentKeys(getAllNotMatchingPartIds()); // set all not matching
    }

    setTimeout(() => {
      const $scrollList = $(".lm-content--groups");
      const $scrollToFeature = $(".lm-content--groups [data-key="+lookFeature.partId+"]");
      if ($scrollList && $scrollToFeature && $scrollToFeature[0].offsetTop) {
        $scrollList.animate({scrollTop: $scrollToFeature[0].offsetTop}, 600);
      }
    }, 300)
    handleClose(event)
  }

  const getTitle = () => {
    if (deletedFromCart) {
      return "look.style.alert.deleted.title"
    }
    return "look.style.alert.title"
  }

  const getText = () => {
    if (deletedFromCart) {
      return "look.style.alert.deleted.text"
    }
    return "look.style.alert.text"
  }

  return (
    <Popper open={styleAlertModalOpened}
            className="lk-title__modal"
            id={"style-modal"}
            anchorEl={anchorEl.current}
            placement={isMobile ? "bottom-end" : "right"}
            transition
            disablePortal={false}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: isMobile ? "top center" : "left center" }}
        >
          <Paper className="lk-title__modal-paper  lk-title__modal-paper--mobile-top">
            <ClickAwayListener onClickAway={handleClose}>
              <div  className="lk-title__modal-paper-content">
                <h3 className="h3">
                  <FormattedMessage id={getTitle()}/>
                </h3>
                <p>
                  <FormattedMessage id={getText()}/>
                </p>
                <p className="text-right">
                  <Button className={"look-button look-button--primary look-button--yellow"}
                          onClick={reviewYourLookButtonClick}>
                    <FormattedMessage id="look.style.alert.button"/>
                  </Button>
                </p>
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

LookFeatureMatchingStyleAlertModal.propTypes = {
  lookFeature: PropTypes.shape(featureInterface).isRequired,
  deletedFromCart: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
  }
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookParentKeys,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookFeatureMatchingStyleAlertModal)
